var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-4 lg:p-8",attrs:{"id":"CalendarContainer"}},[_c('bookings-nav-select-date'),_c('bookings-nav-refresh-control')],1)}
var staticRenderFns = []

export { render, staticRenderFns }